import React from 'react';
import { FaSearch } from 'react-icons/fa';
import './search-field.css';

const SearchField = ({
  value = '',
  onChange,
  placeholder = 'Rechercher...',
  large = false,
  disabled = false,
  onKeyUp,
  onClear,
  variant = 'default', // 'default', 'client', 'contract'
  className = '',
  style = {},
  ...props
}) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  const handleKeyUp = (e) => {
    if (onKeyUp) {
      onKeyUp(e);
    }
  };

  const handleClear = () => {
    const event = {
      target: { value: '' }
    };
    if (onChange) {
      onChange(event);
    }
    if (onClear) {
      onClear();
    }
  };

  const getSearchFieldClass = () => {
    let baseClass = 'search-field-container';
    
    if (large) {
      baseClass += ' search-field-large';
    }
    
    if (variant !== 'default') {
      baseClass += ` search-field-${variant}`;
    }
    
    if (className) {
      baseClass += ` ${className}`;
    }
    
    return baseClass;
  };

  return (
    <div className={getSearchFieldClass()} style={style}>
      <div className="search-field-input-wrapper">
        <div className="search-field-icon">
          <FaSearch />
        </div>
        <input
          type="text"
          className="search-field-input"
          value={value}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
          placeholder={placeholder}
          disabled={disabled}
          autoComplete="off"
          readOnly
          onFocus={(e) => e.target.removeAttribute('readonly')}
          {...props}
        />
      </div>
    </div>
  );
};

export default SearchField;
